module.exports = "/img/33.cbef54.webp";